import { render, staticRenderFns } from "./LdpFormBaiViet.vue?vue&type=template&id=58cb9638&scoped=true&"
import script from "./LdpFormBaiViet.vue?vue&type=script&lang=js&"
export * from "./LdpFormBaiViet.vue?vue&type=script&lang=js&"
import style0 from "./LdpFormBaiViet.vue?vue&type=style&index=0&id=58cb9638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb9638",
  null
  
)

export default component.exports